import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout/Index.vue";

Vue.use(VueRouter);

//用户解决访问相同路由时报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
//noCache:是否缓存  noTag: 是否显示sidebar icon:sidebar显示的logo noTag: 是否显示tagsview
export const baseRouters = [
  // {
  //   path: "/",
  //   component: Layout,
  //   redirect: "/master",
  //   meta: { title: "运营商管理", noCache: true, icon: "yysgl" },
  //   children: [
  //     {
  //       path: "master",
  //       component: resolve => require(["@/views/city/CityList"], resolve),
  //       name: "Master",
  //       meta: { title: "运营商列表", noCache: true }
  //     },
  //     {
  //       path: "assign",
  //       component: resolve => require(["@/views/assign/Assign"], resolve),
  //       name: "Assign",
  //       meta: { title: "管培指派", noCache: true }
  //     },
  //     {
  //       path: "master/detail/:id",
  //       component: resolve => require(["@/views/city/CityDetail"], resolve),
  //       name: "CityDetail",
  //       meta: { title: "同城详情", hidden: true },
  //       beforeEnter: (to, from, next) => {
  //         for (const item of to.matched) {
  //           if (item.path == "/master/detail/:id") {
  //             item.meta.title = to.query.name ? to.query.name : "同城详情";
  //             document.title = item.meta.title + "-中台管理系统";
  //           }
  //         }
  //         next();
  //       }
  //     },
  //     {
  //       path: "/master/out_detail",
  //       component: resolve => require(["@/views/city/CityOutDetail"], resolve),
  //       name: "CityDetailOut",
  //       meta: {
  //         title: "外卖活动记录详情",
  //         noCache: true,
  //         hidden: true
  //       }
  //     },
  //     {
  //       path: "/master/out_detail",
  //       component: resolve => require(["@/views/city/CityEcomDetail"], resolve),
  //       name: "CityDetailEcom",
  //       meta: {
  //         title: "电商活动记录详情",
  //         noCache: true,
  //         hidden: true
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: "/task",
  //   component: Layout,
  //   meta: { title: "任务管理", noCache: true, icon: "rwgl" },
  //   children: [
  //     {
  //       path: "",
  //       component: resolve => require(["@/views/task/Task"], resolve),
  //       name: "Task",
  //       meta: { title: "任务管理", noCache: true }
  //     },
  //     {
  //       path: "add",
  //       component: resolve => require(["@/views/task/AddTask"], resolve),
  //       name: "AddTask",
  //       meta: { title: "发布", noCache: true, hidden: true }
  //     }
  //   ]
  // },
  // {
  //   path: "/train",
  //   component: Layout,
  //   meta: { title: "培训管理", noCache: true, icon: "pxgl" },
  //   children: [
  //     {
  //       path: "",
  //       component: resolve => require(["@/views/train/Train"], resolve),
  //       name: "Train",
  //       meta: { title: "培训课程", noCache: true }
  //     },
  //     {
  //       path: "add/:cid",
  //       component: resolve => require(["@/views/train/AddTrain"], resolve),
  //       name: "AddTrain",
  //       meta: { title: "添加课程", noCache: true, hidden: true }
  //     },
  //     {
  //       path: "edit",
  //       component: resolve => require(["@/views/train/AddTrain"], resolve),
  //       name: "EditTrain",
  //       meta: { title: "编辑课程", noCache: true, hidden: true }
  //     }
  //   ]
  // },
  // {
  //   path: "/limit",
  //   component: Layout,
  //   meta: { title: "权限管理", noCache: true, icon: "qxgl" },
  //   children: [
  //     {
  //       path: "",
  //       component: resolve => require(["@/views/limit/Limit"], resolve),
  //       name: "Limit",
  //       meta: { title: "权限管理", noCache: true }
  //     }
  //   ]
  // },
  {
    path: "/login",
    component: resolve => require(["@/views/Login"], resolve),
    name: "Login",
    meta: { title: "登录", noCache: true, hidden: true }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: { title: "跳转中", noCache: true, hidden: true },
    children: [
      {
        path: "/redirect/:path*",
        component: resolve => require(["@/views/error/redirect"], resolve)
      }
    ]
  }
];

export default new VueRouter({
  mode: "history",
  routes: baseRouters
});
